.statusBar {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex: none;
  height: var(--statusbar-height);
  padding: 0 var(--spacing-md);
  border-top: 1px solid var(--color-border);
  background: var(--color-surface);
  font-size: var(--font-size-sm);
}

.items {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  white-space: nowrap;
}

.item {
  display: inline-flex;
  gap: var(--spacing-xs);
}

.itemLabel {
  color: var(--color-text-muted);
}

.itemValue {
  font-weight: var(--font-weight-medium);
}

.toggles {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: none;
}

/* The status bar is slimmer than the toolbar, but toggles keep a generous touch target. */
.toggleButton {
  width: 36px;
  height: 32px;
}
